/* eslint-disable import/prefer-default-export */
/* eslint-disable */

export const VOLUME_FADE = {
  IN: 'in',
  OUT: 'out',
  NONE: 'none',
}
